import fadeIn from '../util/fade-in';
import fadeOut from '../util/fade-out';

const selectors = {
  promoModal: '#PromoModal',
  close: '.close',
  dataDevMode: 'data-dev-mode',
  cookieName: 'promo',
  modalWrapper: '.modal__wrapper',
};

export function showPromo() {
  let promoDevMode = false;
  if (document.querySelector(selectors.promoModal) && document.querySelector(selectors.promoModal).getAttribute(selectors.dataDevMode)) {
    promoDevMode = document.querySelector(selectors.promoModal).getAttribute(selectors.dataDevMode);
    promoDevMode = promoDevMode === 'true';
  }

  let PromoCookie = {};
  PromoCookie.cookie = {
    configuration: {
      expires: null, // session cookie
      path: '/',
      domain: window.location.hostname,
    },
    name: selectors.cookieName,
    write: function (promo) {
      const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find((row) => row.startsWith(this.name));
      if (hasCookie || document.cookie.indexOf('; ') === -1) {
        document.cookie = `${this.name}=${promo}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    },
    read: function () {
      if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
        const returnCookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith(this.name))
          .split('=')[1];

        return returnCookie;
      }
    },
    destroy: function () {
      if (document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
        const emptyCookie = null;
        document.cookie = `${this.name}=${emptyCookie}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    },
  };

  const cookieExists = promoDevMode ? false : PromoCookie.cookie.read();

  if (!cookieExists) {
    if (!promoDevMode) {
      PromoCookie.cookie.write(selectors.cookieName);
    }

    const thisModal = document.querySelector(selectors.promoModal);
    const close = thisModal.querySelector(selectors.close);

    fadeIn(thisModal);

    close.addEventListener('click', function (e) {
      e.preventDefault();
      fadeOut(thisModal);
    });

    // Close on overlay click
    thisModal.addEventListener('click', function (e) {
      if (e.target === thisModal.querySelector(selectors.modalWrapper)) {
        fadeOut(thisModal);
      }
    });
  }
}
